import Button from 'blocks/Button';
import Input from 'blocks/Input';
import Breadcrumb from 'components/Breadcrumb';
import TermsCondition from 'components/TermsCondition';
import Paths from 'helper/paths';
import { buyMilageTerms } from 'helper/static-constant';
import { useForm } from 'hooks/useForm';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import { useTranslation } from 'react-i18next';

import * as S from './buymilage.styles';
const BuyMilage = () => {
  const { t } = useTranslation();
  const breadcrumbLinks = [
    {
      title: t(`pageTitles.${Paths.Dashboard.index().name}`),
      url: Paths.Dashboard.index().route,
      active: true,
    },
    {
      title: t(`pageTitles.${Paths.Services.buyMilage().name}`),
      url: '',
      active: false,
    },
  ] as BreadcrumbInterface[];

  //   const [gatewayForm, setGatewayForm] = useState<any>(null);
  //   const gatewayFormRef = useRef<any>();

  //   const buyMileRecieptModal = useRef<any>(null);

  const { inputFields, handleChange } = useForm({
    miles: {
      name: 'miles',
      value: '',
      type: 'number',
      label: t('pages.services.buyMilage.sections.forms.sections.milesToBuy.fields.miles.label'),
      placeholder: t('pages.services.buyMilage.sections.forms.sections.milesToBuy.fields.miles.placeholder'),
    },
  });

  const buyMiles = async () => {
    // const res = await ajax({
    //     url: urls.purchase,
    //     method: 'POST',
    //     data: {
    //         mile: inputFields.miles.value,
    //         callback: "http://google.com"
    //     }
    // })
    // if(!res) return
    // setGatewayForm(res)
    // gatewayFormRef.current.openModal();
  };

  return (
    <WithSidebar>
      <S.BuyMilagePage>
        <Breadcrumb links={breadcrumbLinks} title={t('pages.services.buyMilage.title')} />

        <S.BuyMilagePageBox>
          <S.BuyMilagePageBoxLeft>
            <S.BuyMilagePageBoxLeftCard>
              <S.BuyMilagePageBoxLeftTitle>
                {t('pages.services.buyMilage.sections.forms.sections.milesToBuy.title')}
              </S.BuyMilagePageBoxLeftTitle>
              <Input inputField={inputFields.miles} onChange={handleChange} />
              <S.BuyMilagePageBoxLeftInput>
                {t('pages.services.buyMilage.sections.forms.sections.milesToBuy.fields.miles.hint', { miles: '???' })}
              </S.BuyMilagePageBoxLeftInput>
            </S.BuyMilagePageBoxLeftCard>

            {inputFields.miles.value && (
              <S.BuyMilagePageBoxInputCard>
                <S.BuyMilagePageBoxInputTitle>
                  {t('pages.services.buyMilage.sections.calculationBox.title')}
                </S.BuyMilagePageBoxInputTitle>

                <S.BuyMilagePageBoxGrayCardvalue>
                  <S.BuyMilagePageBoxGrayCardRow>
                    <S.BuyMilagePageBoxGrayCardvalue>
                      {t('pages.services.buyMilage.sections.calculationBox.keyValues.miles')}
                    </S.BuyMilagePageBoxGrayCardvalue>
                    <S.BuyMilagePageBoxGrayCardvalue>{inputFields.miles.value}</S.BuyMilagePageBoxGrayCardvalue>
                  </S.BuyMilagePageBoxGrayCardRow>
                  <S.BuyMilagePageBoxGrayCardRow>
                    <S.BuyMilagePageBoxGrayCardvalue>
                      {t('pages.services.buyMilage.sections.calculationBox.keyValues.cost')}
                    </S.BuyMilagePageBoxGrayCardvalue>
                    <S.BuyMilagePageBoxGrayCardvalue>USD {inputFields.miles.value}</S.BuyMilagePageBoxGrayCardvalue>
                  </S.BuyMilagePageBoxGrayCardRow>
                  {/* <div className="row-list">
                    <div className="key fs-xs">Discount</div>
                    <div className="value fs-xs">USD 1,000.00</div>
                  </div> */}

                  <S.BuyMilagePageBoxGrayCardRow2>
                    <S.BuyMilagePageBoxGrayCardCBlue>
                      {t('pages.services.buyMilage.sections.calculationBox.keyValues.total')}
                    </S.BuyMilagePageBoxGrayCardCBlue>
                    <S.BuyMilagePageBoxGrayCardCBlue>USD 2,000.00</S.BuyMilagePageBoxGrayCardCBlue>
                  </S.BuyMilagePageBoxGrayCardRow2>
                </S.BuyMilagePageBoxGrayCardvalue>
              </S.BuyMilagePageBoxInputCard>
            )}

            <S.BuyMilagePageBoxGrayCardBtn as={Button} styleType="default" onClick={buyMiles}>
              {t('pages.services.buyMilage.sections.forms.sections.milesToBuy.submitCTA')}
            </S.BuyMilagePageBoxGrayCardBtn>
          </S.BuyMilagePageBoxLeft>
          <S.BuyMilagePageBoxRight>
            <TermsCondition title="Terms & Conditions" termsItem={buyMilageTerms} />
          </S.BuyMilagePageBoxRight>
        </S.BuyMilagePageBox>
      </S.BuyMilagePage>

      {/* <PaymentGatewayForm formData={gatewayForm} ref={gatewayFormRef} id="gatewayForm" /> */}

      {/* <BuyMileRecieptModal ref={buyMileRecieptModal} /> */}
    </WithSidebar>
  );
};

export default BuyMilage;
